export default __webpack_public_path__ + "static/ImpactFees-b702e20edd97090ed4f703e14b8dd97e.jpg";